module.exports = __webpack_public_path__ + "static/media/shareLockGuide5.f4fed53e.png";